import React, { useEffect, useState } from "react";
import axios from "axios";
import { Navigate, useParams } from "react-router-dom";
import GalleryEditor from "components/Gallery/GalleryEditor";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

function UpdateGallery() {
  const { id } = useParams();
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [notification, setNotification] = useState({
    open: false,
    color: "success",
    message: "",
  });

  useEffect(() => {
    const loadGalleryItem = async () => {
      if (init() !== "success") {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${Constants.getUrls.getSingleGallery}${id}`);
        setInitialValues(response?.data?.data || null);
      } catch (error) {
        setNotification({
          open: true,
          color: "error",
          message: error?.response?.data?.message || "Unable to load gallery details.",
        });
      } finally {
        setLoading(false);
      }
    };

    loadGalleryItem();
  }, [id]);

  const handleSubmit = async (form) => {
    if (init() !== "success") {
      return;
    }

    setSubmitLoading(true);

    try {
      const fd = new FormData();
      fd.append("title", form.title);
      fd.append("caption", form.caption);
      fd.append("sort_order", form.sort_order);
      fd.append("status", form.status);

      if (form.image) {
        fd.append("image", form.image);
      }

      const response = await axios.put(`${Constants.putUrls.updateGallery}${id}`, fd);
      setNotification({
        open: true,
        color: "success",
        message: response?.data?.message || "Gallery item updated successfully.",
      });

      setTimeout(() => {
        setRedirect(true);
      }, 1200);
    } catch (error) {
      setNotification({
        open: true,
        color: "error",
        message: error?.response?.data?.message || "Unable to update gallery item.",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  if (redirect) {
    return <Navigate to="/gallery" />;
  }

  if (loading) {
    return null;
  }

  return (
    <GalleryEditor
      title="Update Gallery Item"
      submitLabel="Update Gallery Item"
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitLoading={submitLoading}
      notification={notification.open}
      notificationColor={notification.color}
      notificationMessage={notification.message}
    />
  );
}

export default UpdateGallery;
